<template>
  <div>
    <div class="modal-body">
      <Form class="sm" ref="form" :model="form" :rules="rules" :label-width="110">
        <FormItem label="支付方式" prop="payMethod">
          <sl-select type="radio" :disabled="disabled" dict="$payMethod" v-model="form.payMethod" />
        </FormItem>
        <FormItem label="车辆编号" prop="bizIds">
          <span :title="carNoTitle" style="overflow: hidden;text-overflow: ellipsis;width: 200px;display: inline-block;">{{carNoTitle}}</span>
        </FormItem>
        <FormItem v-show="false" label="bizType" prop="bizType">
          <Input v-model="form.bizType" :disabled="disabled" />
        </FormItem>
        <FormItem :label="amountTitle" prop="totalAmount">
          <InputNumber v-model="form.totalAmount" :precision="2" :min="0.01" :disabled="disabled" :active-change="false" />
          <span style="margin-left:8px;" v-if="isBatch">x {{this.id.length}}辆车</span>
        </FormItem>
        <FormItem v-if="isBatch" label="总计">
          <p>{{totalAmount}}</p>
        </FormItem>
      </Form>
      <div style="text-align: center;" v-show="qrcodeMode">
        <sl-qrcode :content="qrcode" :width="200" :height="200" />
        <p style="margin:1.5em 0;font-size:14px;">
          <Icon type="md-qr-scanner" size="24" style="margin-right:5px;" />扫码完成支付</p>
      </div>
    </div>
    <div class="modal-footer" v-show="!qrcodeMode">
      <Button :loading="loading" :disabled="disabled" @click="handleSubmit('form')" type="primary">{{buttonTitle}}</Button>
    </div>
  </div>
</template>
<script>
import QRCode from 'qrcode'
export default {
  // left315 x top370  168x168
  data() {
    return {
      rules: {
        bizIds: [{ type: 'array', required: true, message: '请输入车辆ID', trigger: 'blur,change' }],
        bizType: [{ type: 'number', required: true, message: '请输入', trigger: 'blur,change' }],
        totalAmount: [{ required: true, type: 'number', message: '请输入充值金额', trigger: 'blur,change' }],
        payMethod: [{ type: 'number', required: true, message: '请选择支付方式', trigger: 'change' }],
      },
      form: {
        bizIds: [],
        bizType: 0,
        payMethod: null,
        totalAmount: null,
      },
      data: '',
      state: 0,
      loading: false,
      modalVisible: false,
      footerVisible: true,
      reqHandler: null,
      orderNo: null,
      el: null,
      qrcode: null,
      winHandler:null,
      payStartTime:0
    }
  },

  computed: {
    buttonTitle() {
      return this.state == 0 ? '支付' : this.state == 1 ? '支付中' : '支付'
    },
    disabled() {
      return this.state == 0 ? false : true
    },
    qrcodeMode() {
      return this.state == 1 && this.form.payMethod == 1
    },
    isBatch() {
      return this.id && Array.isArray(this.id)
    },
    amountTitle() {
      if (this.isBatch) {
        return '每辆充值金额'
      } else {
        return '充值金额'
      }
    },
    title() {
      return this.isBatch ? '车辆批量充值' : '车辆充值'
    },
    totalAmount() {
      if (this.isBatch && this.form.totalAmount) {
        return (this.id.length * this.form.totalAmount).toFixed(2)
      } else {
        return this.form.totalAmount
      }
    },
    carNoTitle() {
      if( this.isBatch ){
        if( this.carNo ){
          return this.carNo.join(',')
        }else{
          return this.id.join(',')
        }
      }else{
        return this.carNo || this.id
      }
    }
  },

  props: {
    id: { type: [Number, String, Array] },
    carNo: { type: [Number, String, Array] },
  },
  mounted() {
    if (this.id) {
      this.init(this.id)
    }
  },
  beforeDestroy() {
    if (this.el) {
      document.body.removeChild(this.el)
    }
    if (this.reqHandler) {
      clearTimeout(this.reqHandler)
      this.reqHandler = null
    }
    if( this.winHandler ){
      this.winHandler.close()
      this.winHandler = null
    }
  },

  methods: {
    init(id) {
      if (id) {
        this.$refs['form'].resetFields()
        this.state = 0
        this.loading = false
        this.form.bizIds = this.isBatch ? id : [parseInt(id)]
        this.form.bizType = 0
        this.modalVisible = true
      }
    },

    save() {
      if( this.form.payMethod == 0 ){
        let win = window.open('','','')
        win.document.write("正在跳转到支付宝，请稍后")
        this.winHandler = win
      }

      let params = { ...this.form }

      this.loading = true
      this.$request.pay(params).then(resp => {
        if (resp.code > 0) {
          this.$Message.error({ content: resp.msg })
        } else {
          if (params.payMethod == 0) {
            this.winHandler.document.write(resp.data)
            this.orderNo = (resp.data.match(/订单号\-(\w+)/) || ['', ''])[1]
          } else if (params.payMethod == 1) {
            this.qrcode = resp.data.codeUrl
            this.orderNo = resp.data.tradeNo
          }
          this.payStartTime = Date.now()
          this.state = 1
          this.checkOrder()
        }
        this.loading = false
      })
    },

    handleSubmit(name) {
      this.$refs[name].validate((valid) => {
        if (valid) {
           this.save()
        } else {
          this.$Message.error('参数错误');
        }
      })
    },
    handleClose() {
      if (this.reqHandler) {
        clearTimeout(this.reqHandler)
        this.reqHandler = null
      }
    },

    checkOrder() {
      let params = { "search": { "tradeSerialNum": this.orderNo, "payStatus": null, "paySource": null }, "pageSize": 10, "pageNum": 1 }
      this.$request.invoices(params).then(resp => {
        if (!resp.code && resp.data.list && resp.data.list.length && resp.data.list[0].payStatus != 0) {
          this.$Modal.success({
            title: '支付成功',
            content: `您已成功支付${this.totalAmount}元`,
            onOk: () => {
              this.modalVisible = false
              this.$emit('ok')
            }
          });
        } else {
          if( Date.now() - this.payStartTime < 5 * 60 * 1000){
            this.reqHandler = setTimeout(() => {
              this.checkOrder()
            }, 500)
          }
        }
      })
    }
  }
}

</script>
